module.exports = __webpack_public_path__ + "static/apple-icon-180x180-7fc8897285be91068a342708d62fb609.png";